/**
 * Improved select
 * @requires SlimSelect
 */
var improvedselect =(function() {
    let selectElements = document.querySelectorAll('[data-improvedselect]');

    // mutation observer
    let observer = new MutationObserver(observeMutations);
    observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: [
            'disabled'
        ]
    });


    Array.prototype.forEach.call(selectElements, apply);


    /**
     * Apply
     * @param Element selectElement
     */
    function apply(selectElement, removedNodes) {
        if (selectElement.improvedSelect) {
            if (selectElement.disabled && selectElement.improvedSelect.config.isEnabled) {
                selectElement.improvedSelect.disable();
            } else if (!selectElement.disabled && !selectElement.improvedSelect.config.isEnabled){
                selectElement.improvedSelect.enable();
            }

            // slim select doesn't update when the main select has removed nodes :(
            // if (removedNodes) {
            //     let data = [];
            //     Array.from(selectElement.options).forEach((option) => {
            //         data.push({
            //             text: option.textContent.trim(),
            //             value: option.value,
            //         });
            //     })
            //     selectElement.improvedSelect.setData(data);
            //     selectElement.improvedSelect.open();
            // }
            return;
        }

        let placeholderOptionElement = selectElement.querySelector('[data-placeholder]');
        let currentElementOptions = getValidJSON(selectElement.getAttribute('data-improvedselect'));

        let options = {
            select: selectElement,
            // allowDeselect: true,
            onChange: (info) => {
                if (!info.class) return;
                addOptionClasses(info.class.split(' '), selectElement);
            }
        };

        if (placeholderOptionElement) {
            options.placeholder = placeholderOptionElement.textContent;
        }
        if (selectElement.multiple) {
            options.closeOnSelect = false;
        }
        if (currentElementOptions) {
            options = merge(options, currentElementOptions);
        }

        options.addable = options.addable ? (value) => value : false;

        if (options.endpoint) {
            options.ajax = fetchResults;
        }

        selectElement.improvedSelect = new SlimSelect(options);

        let currentSelectedOption = selectElement.querySelector('[selected]');
        if (currentSelectedOption) {
            if (!currentSelectedOption.getAttribute('class')) return;
            addOptionClasses(currentSelectedOption.getAttribute('class').split(' '), selectElement);
        }
    }


    /**
     * Add option classes
     * @param {Array} classes
     * @param {Element} selectElement
     */
    function addOptionClasses(classes, selectElement) {
        if (selectElement.improvedSelect.previousOptionClasses) {
            selectElement.improvedSelect.slim.container.children[0].classList.remove(...selectElement.improvedSelect.previousOptionClasses);
        }

        if (!classes.length) return;

        selectElement.improvedSelect.slim.container.children[0].classList.add(...classes);
        selectElement.improvedSelect.previousOptionClasses = classes;
    }


    /**
     * Fetch results
     * @param {String} searchString
     * @param {Function} callback Provided by slim select
     */
    function fetchResults(searchString, callback) {
        let options = getValidJSON(this.select.element.getAttribute('data-improvedselect'));
        let endpoint = options.endpoint.replace('{{searchString}}', searchString);
        let variables = endpoint.match(/{{[-a-zA-Z0-9\[\]]+}}/g);

        if (searchString.length < 2) {
            callback('At least 3 characters');
            return;
        }

        // Iterate over each endpoint variable and find the appropriate control
        // element (a variable is defined as the name of a control element).
        // Replace the variable with the control element's value.
        if (variables) {
            variables.forEach((variable) => {
                let formElement = document.querySelector('[name="' + variable.replace(/{{/g, '').replace(/}}/g, '') + '"]');
                if (!formElement) return;
                endpoint = endpoint.replace(variable, formElement.value);
            });
        }

        fetch(endpoint.replace('{{searchString}}', searchString))
            .then(function(response) {
                return response.json();
            })
            .then(function(json) {
                let data = [];
                json.results.forEach((result) => data.push({
                    value: result.id,
                    // (TODO: maybe add a formatting option for the received data)
                    text: result.name
                }));

                callback(data);
            })
            .catch(function(error) {
                callback(false);
            });
    }

    /**
     * Observe mutations
     * @param {Object} mutationsList
     */
    function observeMutations(mutationsList) {
        for (let mutation of mutationsList) {
            let elements = mutation.target.matches('[data-improvedselect]') ? [mutation.target] : mutation.target.querySelectorAll('[data-improvedselect]');
            if (!elements.length) continue;
            if (mutation.removedNodes.length) {
                let removedNodes = Array.from(mutation.removedNodes).filter((node) => (node.nodeName !== '#text'));
                // for some reason, slim select is not updating
                Array.from(elements).forEach((element) => apply(element, removedNodes));
                return;
            }
            Array.from(elements).forEach((element) => apply(element));
        }
    }
})();
